import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CalculateIcon from '@mui/icons-material/Calculate';
import { formatCurrency } from '../../utils/formatters';

const SectionHeader = ({ title }) => (
  <Box display="flex" alignItems="center" mb={2}>
    <CalculateIcon color="primary" sx={{ mr: 1 }} />
    <Typography variant="h6">{title}</Typography>
  </Box>
);

const FinancialRow = ({ label, valueBRL, valueUSD }) => (
  <TableRow>
    <TableCell component="th" scope="row">
      {label}
    </TableCell>
    <TableCell align="right">{formatCurrency(valueBRL, 'BRL')}</TableCell>
    <TableCell align="right">{formatCurrency(valueUSD, 'USD')}</TableCell>
  </TableRow>
);

/**
 * DistributionExpensesSection - Mirrors the Capa Rel. Imp. DESPESAS block.
 * Total Expenses = Customs Expenses + Inland Freight.
 * @param {Object} props - Component props
 * @param {Object} props.order - Order data
 */
const DistributionExpensesSection = ({ order }) => {
  if (!order) return null;

  const taxCalculation = order.latest_tax_calculation || {};
  const exchangeRate = taxCalculation.exchange_rate_dollar_to_real || 1;

  const despesasAduaneiras = Number(taxCalculation.despesas_aduaneiras) || 0;
  const logisticaInterna = Number(taxCalculation.frete_rod_interno) || 0;
  const totalDespesas = despesasAduaneiras + logisticaInterna;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <SectionHeader title="EXPENSES" />
        <TableContainer component={Paper} variant="outlined">
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell align="right">BRL</TableCell>
                <TableCell align="right">USD</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <FinancialRow
                label="Customs Expenses"
                valueBRL={despesasAduaneiras}
                valueUSD={despesasAduaneiras / exchangeRate}
              />
              <FinancialRow
                label="Inland Freight"
                valueBRL={logisticaInterna}
                valueUSD={logisticaInterna / exchangeRate}
              />
              <TableRow sx={{ backgroundColor: 'rgba(0, 0, 0, 0.04)' }}>
                <TableCell component="th" scope="row">
                  <Typography fontWeight="bold">Total Expenses</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(totalDespesas, 'BRL')}</Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography fontWeight="bold">{formatCurrency(totalDespesas / exchangeRate, 'USD')}</Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};

export default DistributionExpensesSection;
